import { useCallback } from "react"
import { createFileName, useScreenshot } from "usescreenshot-react"

const downloadImg = (image: string, { name = "img", extension = "jpg" } = {}) => {
    const a = document.createElement("a")
    a.href = image
    a.download = createFileName(extension, name)
    a.click()
}
interface ScreenshotProps {
    backgroundColor: string
    logging: boolean
    removeContainer?: boolean
    scale?: number
}
export function useDownloadScreenshot<T extends HTMLElement>(
    ref: React.RefObject<T>,
    screenshotOption: ScreenshotProps = {
        backgroundColor: "#26282A",
        logging: true,
        removeContainer: true,
        scale: 3.5,
    },
) {
    const { takeScreenshot, isLoading } = useScreenshot()
    const getImage = useCallback(() => {
        if (!ref.current) {
            return
        }
        takeScreenshot(ref.current, screenshotOption).then(downloadImg).catch(console.log)
    }, [takeScreenshot, screenshotOption, ref])

    return {
        getImage,
        isLoading,
    }
}
